module.exports = __webpack_public_path__ + "assets/c0bdf97edeb16d715eab21354c99ee21.svg";